var swiper = new Swiper('.popular-departments .pds-swiper', {
    spaceBetween: 12,
    slidesPerView: 'auto',
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      769: {
        spaceBetween: 16,
      },
      1024: {
        spaceBetween: 20,
      }
    },
    navigation: {
      nextEl: '.popular-departments .pds-header .pds-pagination .swiper-button-next',
      prevEl: '.popular-departments .pds-header .pds-pagination .swiper-button-prev',
    }
  });